// extracted by mini-css-extract-plugin
export default {"cta":"AK-z","disabled":"BK-z"};